const ACTION_TYPES = {
	UN_AFFECTIVE: 'unAffective',
};

/**
 * @module types
 */
export default ACTION_TYPES;
